/**
 * Count input with increment (+) and decrement (-) buttons
 */

export default (() => {
  const container = document.body

  const handleIncrement = (event) => {
    if (!event.target.closest('[data-increment]')) return

    const input = event.target
      .closest('.count-input')
      .querySelector('.form-control')
    const maxValue = parseInt(input.getAttribute('max')) || Infinity

    if (input.value < maxValue) {
      input.value++
      updateButtonStates(input)
    }
  }

  const handleDecrement = (event) => {
    if (!event.target.closest('[data-decrement]')) return

    const input = event.target
      .closest('.count-input')
      .querySelector('.form-control')
    const minValue = parseInt(input.getAttribute('min')) || 0

    if (input.value > minValue) {
      input.value--
      updateButtonStates(input)
    }
  }

  const updateButtonStates = (input) => {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]')
    const incrementBtn = input.parentNode.querySelector('[data-increment]')
    const minValue = parseInt(input.getAttribute('min')) || 0
    const maxValue = parseInt(input.getAttribute('max')) || Infinity

    decrementBtn.disabled = input.value <= minValue
    incrementBtn.disabled = input.value >= maxValue

    const parent = input.closest('.count-input')
    if (!parent.classList.contains('count-input-collapsible')) return

    const inputValue = parent.querySelector('[data-count-input-value]')

    if (input.value > 0) {
      parent.classList.remove('collapsed')
      if (inputValue) {
        inputValue.textContent = input.value
      }
    } else {
      parent.classList.add('collapsed')
      if (inputValue) {
        inputValue.textContent = ''
      }
    }
  }

  // 親要素にイベントをバインドして、動的要素にも対応
  container.addEventListener('click', handleIncrement)
  container.addEventListener('click', handleDecrement)

  // 初期状態のボタン更新
  document.querySelectorAll('.count-input .form-control').forEach((input) => {
    updateButtonStates(input)
  })
})()
